import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getInProgress, getShow, getSourceTaskIds, getTitle } from "./redux/selectors";
import TasksLogs from "./tasksLogs";
const mapStateToProps = (state) => ({
    subTasksIds: getSourceTaskIds(state),
    isOpen: getShow(state),
    title: getTitle(state),
    inProgress: getInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    getTasksLogs: (sourceTaskIds, completed, rejected) => dispatch(actionCreators.getTasksLogs(sourceTaskIds, completed, rejected)),
    onClose: () => dispatch(actionCreators.toggleTasksLogsResult(false, []))
});
export default connect(mapStateToProps, mapDispatchToProps)(TasksLogs);
